


























































































import { OptionsType } from '@/pages/profile/views/general/types';
import { Input as FormInput, Select as FormSelect } from '@/components/form';
import { validateSnils } from '@/tools/validateSnils';
import { validationMixin } from 'vuelidate';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import { GENDERS } from '@/components/ordersProcessForms/parts/AdditionalDataStep/type';
import { format } from 'date-fns';
const AVAILABLE_FIELDS = [
  'region_id',
  'municipality_id',
  'birthday',
  'sex',
  'snils',
  'edu_level_id',
];
export default {
  name: 'DynamicAdditionalDataForm',
  mixins: [validationMixin],
  components: {
    AppButtonNew,
    FormInput,
    FormSelect,
  },
  props: {
    // fields: {
    //   type: Array,
    //   require: true,
    //   validator: (value: Array<string>) =>
    //     value.filter((el: string) => AVAILABLE_FIELDS.includes(el)).length ===
    //     value.length,
    // },
    errors: {},
    nextStep: {
      type: Function,
    },
  },
  data() {
    return {
      fields: [],
      municipality_id: '',
      edu_level_id: '',
      region_id: '',
      sex: 'N',
      birthday: '',
      snils: '',
    };
  },
  computed: {
    regionsDict() {
      return this.$store.state.regionsDict.map((m: { id: any; name: any }) => ({
        value: m.id,
        text: m.name,
      }));
    },

    genderOptions() {
      return GENDERS;
    },

    municipalitetDict() {
      return this.$store.state.municipalities.map(
        (item: { name: any; id: any }) => ({
          text: item.name,
          value: item.id,
        })
      );
    },
    levelOptions() {
      const { eduLevels } = this.$store.state;
      return eduLevels
        ? [
            ...eduLevels.map(({ name, id }: OptionsType) => ({
              text: name,
              value: id,
            })),
          ]
        : [];
    },
    isDisableMunicipality() {
      const isDisable = !(
        this.$store.state.regionProfile.regionId > 0 &&
        +this.$store.state.regionProfile.regionId === +this.region_id
      );
      if (isDisable) this.municipality_id = '';
      return isDisable;
    },
    getErrors() {
      const ret: any = {};
      (this.errors || []).forEach((error: any) => {
        ret[error['attribute']] = error.msg;
      });
      return ret;
    },
    dateMask() {
      return [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];
    },
    snilsMask: () => [
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      ' ',
      /\d/,
      /\d/,
    ],
  },
  validations: {
    municipality_id: {
      required: async (value: string, context: any) => {
        const readyContext = await context;
        const isFieldAvailableToValidation =
          readyContext.fields.includes('municipality_id');
        if (isFieldAvailableToValidation) {
          const isEqualWithRegionProfileId =
            readyContext.$store.state.regionProfile.regionId ==
            readyContext.region_id;
          return isEqualWithRegionProfileId
            ? !!readyContext.municipality_id
            : true;
        }
        return true;
      },
    },
    region_id: {
      required: (value: string, context: any) => {
        const isFieldAvailableToValidation =
          context.fields.includes('region_id');
        return isFieldAvailableToValidation ? !!context.region_id : true;
      },
    },
    edu_level_id: {
      required: (value: number, context: any) => {
        const isFieldAvailableToValidation =
          context.fields.includes('edu_level_id');
        return isFieldAvailableToValidation
          ? !!value && Number(value) !== 0
          : true;
      },
    },
    snils: {
      validateSnils: (value: string, context: any) => {
        const isFieldAvailableToValidation = context.fields.includes('snils');
        return isFieldAvailableToValidation
          ? !!value && validateSnils(value)
          : true;
      },
    },
    birthday: {
      required: (value: string, context: any) => {
        const isFieldAvailableToValidation =
          context.fields.includes('birthday');
        const birthdayTestRegular = RegExp(
          `^\\s*(3[01]|[12][0-9]|0?[1-9])\\.(1[012]|0?[1-9])\\.(19[2-9][0-9]|20${context.getStrRegxPatternBeforeCurrentYear()})\\s*$`
        );
        // 30.08.1990 заглушка
        return isFieldAvailableToValidation
          ? !!value && birthdayTestRegular.test(value ? value : '30.08.1990')
          : true;
      },
    },
    sex: {
      required: (value: string, context: any) => {
        const isFieldAvailableToValidation = context.fields.includes('sex');
        return isFieldAvailableToValidation ? !!value && value !== 'N' : true;
      },
    },
  },
  methods: {
    async sendAdditionalUserData() {
      const parseDate = this.birthday.split('.');
      const birthday = parseDate
        ? format(
            new Date(
              Number(parseDate[2]),
              Number(parseDate[1]) - 1,
              Number(parseDate[0])
            ),
            'YYYY-MM-DD'
          )
        : parseDate;
      try {
        const submitData = {
          ...(this.municipality_id && {
            municipality_id: this.municipality_id,
          }),
          ...(this.edu_level_id && { edu_level_id: this.edu_level_id }),
          ...(this.region_id && { region_id: this.region_id }),
          ...(this.sex && { sex: this.sex }),
          ...(birthday && { birthday: birthday }),
          ...(this.snils && { snils: this.snils }),
        };
        await this.$axiosInstance.post('profile/update/required', {
          data: submitData,
        });
        this.nextStep();
      } catch (e) {
        console.log(e);
      }
    },
    async loadDeficitFields() {
      try {
        const {
          data: { data: userData },
        } = await this.$axiosInstance.post(`profile/get-required-params`);
        console.log(userData);
        if (userData.is_deficit_user_data) {
          this.fields = userData.deficit_fields;
        } else {
          this.nextStep();
        }
      } catch (e) {
        this.nextStep();
      }
    },
    getStrRegxPatternBeforeCurrentYear() {
      function getCurrentYearByOctetIndex(index: any) {
        const curYear = new Date().getFullYear().toString().split('');
        return curYear[index];
      }
      const rex = `([0-1][\\d]|2[0-${getCurrentYearByOctetIndex(3)}])`;
      return rex;
    },
    touchValidationAndEmitValidationState() {
      this.fields.forEach((el: string) => {
        this.$v[el].$touch();
      });
      const isInvalid = this.$v.$invalid;
      return isInvalid;
      // if (!isInvalid) {
      //   const payload = this.collectData();
      //   console.log('READY FOR INPUT: ', payload);
      //   this.$emit('submit', payload);
      // }
      // this.$emit('validation', isInvalid);
    },
    collectData() {
      const payload: any = {};
      this.fields.forEach((el: string) => {
        payload[el] = this[el];
      });
      return payload;
    },
    startWatching() {
      this.$nextTick(() => {
        const watchFields = this.fields;
        watchFields.forEach((el: string) => {
          this.$watch(el, () => {
            this.touchValidationAndEmitValidationState();
          });
        });
      });
    },
    initialValidation() {
      this.touchValidationAndEmitValidationState();
      this.$v.$reset();
    },
  },
  created() {
    this.region_id = this.$store.state.regionProfile?.regionId || '';
  },
  async mounted() {
    await this.loadDeficitFields();
    this.initialValidation();
    // fields Observer
    // TODO: если будет необходимость валидации после нажатия на далее - необходимо сделать пропс и связать его с внешним компонентом
    this.$watch('fields', () => {
      this.startWatching();
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ordersProcessForms/parts/AdditionalDataStep/DynamicAdditionalDataForm.vue